import { get, put, del } from '@/services/http';

export interface IReorderUserParams {
  dateRange: string[];
  showNeedReorderNowOnly: boolean;
  reportParams: Array<{
    code: string;
    name: string;
    value: string[];
    valueType: string;
    dataType: string;
  }>;
  expanded: boolean;
  timestamp?: number;
}

export interface IReorderUserParamsResponse {
  success: boolean;
  data: IReorderUserParams;
  message?: string;
  meta?: {
    lastUpdated: string;
    version: number;
  };
}

export class ReorderUserParamsService {
  private static readonly API_PATH = '/settings/reorder-user-params';

  /**
   * Get saved reorder user params from database
   */
  public static async get(): Promise<IReorderUserParams | null> {
    try {
      const response: IReorderUserParamsResponse = await get(this.API_PATH);
      if (response.success && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Failed to get reorder user params:', error);
      return null;
    }
  }

  /**
   * Save reorder user params to database
   */
  public static async save(params: Partial<IReorderUserParams>): Promise<boolean> {
    try {
      const response: IReorderUserParamsResponse = await put(this.API_PATH, params);
      return response.success;
    } catch (error) {
      console.error('Failed to save reorder user params:', error);
      return false;
    }
  }

  /**
   * Delete reorder user params from database
   */
  public static async delete(): Promise<boolean> {
    try {
      const response: any = await del(this.API_PATH);
      return response.success;
    } catch (error) {
      console.error('Failed to delete reorder user params:', error);
      return false;
    }
  }
}